export default 'https://tme.understood.org/assets/speakers.ab15467e.glb'